import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Button, Menu, MenuButton, MenuList } from '@tq/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isActive: boolean;
};

export const MobileMoreTab: React.FC<Props> = ({ children, isActive }) => {
  const { t } = useTranslation('more');
  return (
    <Menu variant='withTab' closeOnSelect>
      <MenuButton
        variant='tab'
        sx={{
          height: '3.5rem',
          width: '33%',
          minWidth: '33%',
          borderBottomColor: isActive ? COLOURS.blue[400] : undefined,
          borderRadius: '0',
          bg: 'grey.100',
          '&:focus': {
            clipPath: 'inset(-5px -5px 0px -5px)',
            background: 'transparent !important',
            color: 'inherit !important',
          },
        }}
        as={Button}
      >
        {t('more', 'More')}...
      </MenuButton>
      <MenuList>{children}</MenuList>
    </Menu>
  );
};
